import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Button from "@mui/material/Button";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import React from "react";
import styled from "styled-components";
import { ChipNeutral } from "./AdminWebhooksListView.styles";
import { FlexColumnDiv } from "./common.styles";
import { HXDialogHeader } from "./HXDialog";
export const WebhookDetailParent = styled(FlexColumnDiv) `
    gap: 20px;
    margin-top: 8px;
`;
export const BackLink = styled(Button).attrs({ variant: "text", startIcon: React.createElement(ChevronLeftIcon) }) `
    align-self: flex-start;
    text-transform: none;
    padding: 2px 8px 2px 4px;
    min-width: 0;
    color: ${colors.black_lighter};
`;
export const DetailHeader = styled.div `
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    flex-wrap: wrap;
`;
export const DetailHeaderMain = styled.div `
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
`;
export const DetailTitleRow = styled.div `
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
`;
export const DetailTitle = styled.div `
    font-size: ${fontSizes.LARGE};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
`;
export const DetailMetaLine = styled.div `
    font-size: ${fontSizes.LITTLE};
    color: ${colors.black_lighter};
`;
export const DetailActions = styled.div `
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
`;
export const MetaGrid = styled.div `
    display: grid;
    grid-template-columns: 200px 1fr;
    border: 1px solid ${colors.black_12};
    border-radius: 6px;
    overflow: hidden;

    /* Drop the bottom border on the final row (the last key/value pair). */
    & > *:nth-last-child(-n + 2) {
        border-bottom: none;
    }
`;
export const MetaKey = styled.div `
    padding: 12px 16px;
    background-color: ${colors.black_4};
    border-bottom: 1px solid ${colors.black_12};
    color: ${colors.black_lighter};
    font-size: ${fontSizes.SMALL};
`;
export const MetaValue = styled.div `
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    padding: 12px 16px;
    border-bottom: 1px solid ${colors.black_12};
    color: ${colors.black_main};
    font-size: ${fontSizes.SMALL};
`;
export const MetaValueMuted = styled.span `
    color: ${colors.black_lighter};
`;
export const ScopeModeLabel = styled.span `
    font-size: ${fontSizes.TINY};
    color: ${colors.black_lighter};
`;
export const EventChip = styled(ChipNeutral) `
    font-family: monospace;
`;
export const RotateInlineButton = styled(Button).attrs({ variant: "text", size: "small" }) `
    text-transform: none;
    min-width: 0;
    padding: 2px 8px;
    color: ${colors.blue_main};
`;
export const DangerZone = styled.div `
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 16px;
    background-color: ${colors.black_4};
    border-left: 3px solid ${colors.tulip_30};
    border-radius: 4px;
`;
export const DangerZoneTitle = styled.div `
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
`;
export const DangerZoneText = styled.div `
    font-size: ${fontSizes.SMALL};
    color: ${colors.black_lighter};
    line-height: 1.5;
`;
export const EditWebhookDialogHeader = styled(HXDialogHeader) `
    padding-bottom: 20px;
`;
